import Store from '@/api/models/store/Store'
import md5 from 'md5'
import Account from '@/api/models/Account'

function getStoreCodeHash(account: Account, cityCode: number): string {
    const key = `${account.id}-${cityCode}`

    return md5(key).toString()
}

function getStoreAddressHash(account: Account, store: Store): string {
    const key = store.address
        ? `${account.id}-${store.address.countryIso}\
        -${store.address.region}-${store.address.city}-${store.address.cityId}`
        : `${account.id}-null-null-null-null`

    return md5(key).toString()
}

export {
    getStoreCodeHash,
    getStoreAddressHash
}
